import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, EntityView } from "@mcurros2/microm";
import { DispositivosOverrides } from "./DispositivosOverrides";

const columns = () =>
(
    {
        c_dispositivo_id: new EntityColumn<string>({
            name: 'c_dispositivo_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Dispositivo Id',
            description: 'Id entificador único del dispositivo, generado automáticamente por el sistema'
        },),
        vc_descripcion: new EntityColumn<string>({
            name: 'vc_descripcion', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Descripción',
            description: 'Descripción del dispositivo'
        }),
        vc_marca: new EntityColumn<string>({
            name: 'vc_marca', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Marca',
            description: 'Marca del dispositivo'
        }),
        vc_modelo: new EntityColumn<string>({
            name: 'vc_modelo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Modelo',
            description: 'Modelo del dispositivo'
        }),
        vc_numeroserie: new EntityColumn<string>({
            name: 'vc_numeroserie', type: 'varchar', length: 50, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Numero de serie',
            description: 'Número de serie del dispositivo'
        }),
        vc_numerolinea: new EntityColumn<string>({
            name: 'vc_numerolinea', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Numero de linea',
            description: 'Número de línea telefónica del dispositivo'
        }),
        b_asegurado: new EntityColumn<boolean>({
            name: 'b_asegurado', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Asegurado',
            description: 'Indica si el dispositivo está asegurado'
        }),
        vc_asignado_a: new EntityColumn<string>({
            name: 'vc_asignado_a', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal Asignado',
                description: 'Persona a la que está asignado el dispositivo'
        }),
        vc_especificaciones: new EntityColumn<string>({
            name: 'vc_especificaciones', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Especificaciones',
            description: 'Especificaciones técnicas del dispositivo'
        }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        disp_brwStandard: { name: 'disp_brwStandard', keyMappings: { c_dispositivo_id: 0 }, gridColumnsOverrides: DispositivosOverrides } as EntityView
    }
)


export class DispositivosDef extends EntityDefinition {

    columns = columns();
    views = views();


    constructor() {
        super('Dispositivos');
    }
}
